export const isDocPro = () => window.location.hostname === 'my.doc-plus.pro'
